import { useRootOutcomesStore } from './root-outcomes.store';
import { Optional, RootOutcome } from 'src/types';

export const useRootOutcome = (outcomeId: string) => {
  const getRootOutcome = useRootOutcomesStore((state) => state.getRootOutcome);
  const setRootOutcome = useRootOutcomesStore((state) => state.setRootOutcome);
  const removeRootOutcome = useRootOutcomesStore((state) => state.removeRootOutcome);

  const rootOutcome = getRootOutcome(outcomeId);

  const saveRootOutcome = (outcome: Optional<RootOutcome>) => {
    setRootOutcome(outcomeId, outcome);
  };

  const removeThisOutcome = () => {
    removeRootOutcome(outcomeId);
  };

  return { 
    rootOutcome, 
    saveRootOutcome, 
    removeRootOutcome: removeThisOutcome 
  };
};